import { createRouter, createWebHistory } from "vue-router";

const PreferencesStepOne = () =>
  import(
    "../components/catalog/preferencesQuestionnaire/PreferencesStepOne.vue"
  );
const PreferencesStepTwo = () =>
  import(
    "../components/catalog/preferencesQuestionnaire/PreferencesStepTwo.vue"
  );
const PreferencesStepThree = () =>
  import(
    "../components/catalog/preferencesQuestionnaire/PreferencesStepThree.vue"
  );
const PreferencesResults = () =>
  import(
    "../components/catalog/preferencesQuestionnaire/PreferencesResults.vue"
  );

const routes = [
  {
    path: "/picks-for-you",
    name: "home",
    children: [
      {
        path: "/picks-for-you/step-one",
        name: "one",
        component: PreferencesStepOne
      },
      {
        path: "/picks-for-you/step-two",
        name: "two",
        component: PreferencesStepTwo
      },
      {
        path: "/picks-for-you/step-three",
        name: "three",
        component: PreferencesStepThree
      },
      {
        path: "/picks-for-you/your-results",
        name: "four",
        component: PreferencesResults
      }
    ]
  }
];

const router = createRouter({
  routes,
  history: createWebHistory(`${window.countryCode}/`),
  scrollBehavior() {
    return { left: 0, top: 0 };
  }
});

export default router;
